import React from 'react';
const NotFoundPage = () => {
    return (React.createElement("div", null,
        React.createElement("p", null, "Page not found.")));
};
export default NotFoundPage;
